export const INSTITUTION_TYPE = {
    AUTHORITY: 1,        // 权力机构    股东会、监事会、董事会
    FUNCTIONAL_DEPARTMENT: 2,       // 职能部门类      综合行政部
    PRODUCTION_DEPARTMENT: 3,       // 生产部门类      市场部、咨询部、工程部、研发部
    BUSINESS_MANAGE: 4,  // 业务管理    项目运营部
    SECOND_MANAGE: 5, // 二级管理，品牌、营销、行政、财务、人事、法务
}

export const INSTITUTION_ID = {
    GENERAL_ASSEMBLY: 1, // 股东会
    SUPERVISORY_BOARD: 2, // 监事会
    BOARD_OF_DIRECTORS: 3, // 董事会
    ADMINISTRATION0_DEPARTMENT: 4, // 综合行政部
    MARKETING_DEPARTMENT: 5, // 市场部
    CONSULTING_DEPARTMENT: 6, // 咨询部
    ENGINEERING_DEPARTMENT: 7, // 工程部
    RD_DEPARTMENT: 8, // 研发部
    OPERATIONS_DEPARTMENT: 9, // 项目运营部
    BRAND: 10, // 品牌
    MARKETING: 11, // 营销
    ADMINISTRATION: 12, // 行政
    FINANCE: 13, // 财务部
    HUMAN_RESOURCES: 14, // 人事
    LEGAL: 15, // 法务
}

/**
 * 其下设置职位的运营部门
 * 用于给员工选部门时选择
 */
export const OperationInstitutionsIds = [
    INSTITUTION_ID.BOARD_OF_DIRECTORS, // 董事会
    INSTITUTION_ID.ADMINISTRATION0_DEPARTMENT, // 综合行政部
    INSTITUTION_ID.MARKETING_DEPARTMENT, // 市场部
    INSTITUTION_ID.CONSULTING_DEPARTMENT, // 咨询部
    INSTITUTION_ID.ENGINEERING_DEPARTMENT, // 工程部
    INSTITUTION_ID.RD_DEPARTMENT, // 研发部
    // INSTITUTION_ID.FINANCE, // 财务部
    INSTITUTION_ID.OPERATIONS_DEPARTMENT, // 项目运营部
]